import { c as _c } from "react/compiler-runtime";
const TailIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M0.508355 0.587022C2.27539 -0.156165 4.23737 -0.126483 6.12945 0.302842C8.02407 0.732803 9.91052 1.57738 11.5836 2.54698C13.259 3.51803 14.7506 4.63178 15.8589 5.62511C16.4124 6.12112 16.881 6.5978 17.233 7.02062C17.5567 7.40957 17.8706 7.85577 17.9752 8.2794C18.0431 8.55564 17.9655 8.84804 17.7691 9.05382L10.2701 16.9054C10.0602 17.1249 9.74712 17.213 9.45367 17.1349C9.16013 17.0566 8.93164 16.8234 8.85894 16.5284C8.23202 13.9845 7.86029 11.6252 6.75152 9.21788C5.66532 6.8598 3.86194 4.46031 0.358941 2.04015C0.108887 1.86726 -0.0268767 1.57106 0.0044492 1.26866C0.0321375 1.00456 0.182967 0.771797 0.40777 0.63878L0.508355 0.587022Z" fill="#F4F4F7" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default TailIcon;